import { EffectiveSessionTimeoutSource } from '@heidi/schema/ml-scribe';
import type { EffectiveSessionTimeout } from '@heidi/workspace/contracts';

/**
 * The PATCH resolves to `null` when the caller is out of cohort (Flagsmith flag
 * off) — fall back to the minutes we just saved so the cache still reflects
 * what the user pressed.
 */
export function resolveSavedSessionTimeout(
  data: EffectiveSessionTimeout | null,
  minutes: number
): EffectiveSessionTimeout {
  if (data) return data;
  return {
    minutes,
    source: EffectiveSessionTimeoutSource.USER,
    is_editable_by_user: true,
  };
}

export function resolveEffectiveSessionTimeout(
  server: EffectiveSessionTimeout | null | undefined,
  override: EffectiveSessionTimeout | null
): EffectiveSessionTimeout | null | undefined {
  if (typeof server?.minutes === 'number' && server.minutes > 0) return server;
  if (typeof override?.minutes === 'number' && override.minutes > 0) return override;
  if (override?.source === EffectiveSessionTimeoutSource.USER_DISABLED) return override;
  return server ?? override ?? null;
}
